{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Transferir para um operador",
    "MESSAGE": "Transfira-me para um operador"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "BAIXAR",
      "UPLOADING": "A carregar..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "submeter"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Enviar mensagem novamente",
      "ERROR_MESSAGE": "Não foi possível enviar, tente novamente"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Avalie a qualidade desta resposta"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Por favor, aguarde até que um agente se junte"
  },
  "ROBOT_CHECK": {
    "TITLE": "Verificação de segurança rápida",
    "DESCRIPTION": "Por favor, complete a verificação abaixo.",
    "VERIFYING": "A verificar…",
    "ERROR": "Isso não funcionou. Por favor, tente novamente.",
    "RETRY": "Tentar novamente"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Estamos online",
    "OFFLINE": "Estamos ausentes",
    "ONLINE_WITH_BOT": "A equipe e nosso assistente de IA estão online",
    "OFFLINE_WITH_BOT": "Nosso assistente de IA está aqui para ajudar",
    "BOT_ONLY_REPLY": "Responde imediatamente"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Normalmente respondemos em poucos minutos",
    "IN_A_FEW_HOURS": "Normalmente respondemos em poucas horas",
    "IN_A_DAY": "Normalmente respondemos num dia",
    "BACK_IN": "Voltaremos online"
  },
  "DAY_NAMES": {
    "SUNDAY": "Domingo",
    "MONDAY": "Segunda-feira",
    "TUESDAY": "Terça-feira",
    "WEDNESDAY": "Quarta-feira",
    "THURSDAY": "Quinta-feira",
    "FRIDAY": "Sexta-feira",
    "SATURDAY": "Sábado"
  },
  "START_CONVERSATION": "Iniciar Conversa",
  "END_CONVERSATION": "Terminar Conversa",
  "CONTINUE_CONVERSATION": "Continuar conversa",
  "YOU": "Você",
  "START_NEW_CONVERSATION": "Iniciar uma nova conversa",
  "RESOLVE_LATER": "Vamos resolver este tópico por e-mail/telefone. Agora quero perguntar outra coisa.",
  "VIEW_UNREAD_MESSAGES": "Tem mensagens por ler",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Ver novas mensagens",
    "CLOSE_MESSAGES_BUTTON": "FECHAR",
    "COMPANY_FROM": "de",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Fale connosco"
  },
  "POWERED_BY": "Desenvolvido por {brandName}",
  "EMAIL_PLACEHOLDER": "Por favor, digite seu e-mail",
  "CHAT_PLACEHOLDER": "Escreva a sua mensagem",
  "TODAY": "Hoje",
  "YESTERDAY": "Ontem",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Nome completo",
        "PLACEHOLDER": "Por favor, digite o seu nome completo",
        "REQUIRED_ERROR": "Nome completo é necessário"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Endereço de e-mail",
        "PLACEHOLDER": "Por favor, insira um endereço de email válido",
        "REQUIRED_ERROR": "O endereço de email é obrigatório",
        "VALID_ERROR": "Por favor, insira um endereço de e-mail válido"
      },
      "PHONE_NUMBER": {
        "LABEL": "Número de telefone",
        "PLACEHOLDER": "Por favor insira o seu número de telefone",
        "REQUIRED_ERROR": "O número de telefone é obrigatório",
        "DIAL_CODE_VALID_ERROR": "Por favor, selecione um código de país",
        "VALID_ERROR": "Por favor, insira um número de telefone válido",
        "DROPDOWN_EMPTY": "Nenhum resultado encontrado",
        "DROPDOWN_SEARCH": "Pesquisar país"
      },
      "MESSAGE": {
        "LABEL": "Messagem",
        "PLACEHOLDER": "Por favor, escreva a sua mensagem",
        "ERROR": "Mensagem muito pequena"
      }
    },
    "CAMPAIGN_HEADER": "Por favor, forneça seu nome e e-mail antes de iniciar a conversa",
    "IS_REQUIRED": "é obrigatório",
    "REQUIRED": "Obrigatório",
    "REGEX_ERROR": "Por favor, introduza um valor válido"
  },
  "FILE_SIZE_LIMIT": "O ficheiro ultrapassa o tamanho limite {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Campo inválido"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Pesquisar emojis",
    "NOT_FOUND": "Nenhum emoji corresponde à sua pesquisa",
    "ARIA_LABEL": "Selecionador de emojis"
  },
  "CSAT": {
    "TITLE": "Avalie a sua conversa",
    "SUBMITTED_TITLE": "Obrigado pela sua avaliação",
    "PLACEHOLDER": "Conte-nos mais..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Pedir a transcrição da conversa",
    "SEND_EMAIL_SUCCESS": "A transcrição do chat foi enviada com sucesso",
    "SEND_EMAIL_ERROR": "Ocorreu um erro, por favor tente novamente"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Artigos Mais Populares",
    "VIEW_ALL_ARTICLES": "Ver todos os artigos",
    "IFRAME_LOAD_ERROR": "Ocorreu um erro ao carregar o artigo. Por favor, atualize a página e tente novamente."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Abrir",
      "BUY": "Comprar"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Mensagem de imagem"
    },
    "audio": {
      "CONTENT": "Mensagem de áudio"
    },
    "video": {
      "CONTENT": "Mensagem de vídeo"
    },
    "file": {
      "CONTENT": "Arquivo anexo"
    },
    "location": {
      "CONTENT": "Local:"
    },
    "fallback": {
      "CONTENT": "compartilhou uma url"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Em resposta a:"
  }
}
